import { setBlockTracking as _setBlockTracking, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-outer-super" }
const _hoisted_2 = ["onPointerdownPassive"]
const _hoisted_3 = { class: "flag top-right" }
const _hoisted_4 = {
  key: 1,
  class: "video"
}
const _hoisted_5 = {
  key: 0,
  class: "time"
}
const _hoisted_6 = { class: "flag bottom-right" }
const _hoisted_7 = { class: "flag bottom-left" }
const _hoisted_8 = {
  key: 0,
  class: "shared-by"
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_RawIcon = _resolveComponent("RawIcon")!
  const _component_VideoIcon = _resolveComponent("VideoIcon")!
  const _component_LivePhotoIcon = _resolveComponent("LivePhotoIcon")!
  const _component_StarIcon = _resolveComponent("StarIcon")!
  const _component_LocalIcon = _resolveComponent("LocalIcon")!
  const _component_XImg = _resolveComponent("XImg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-outer fill-block", {
        selected: _ctx.data.flag & _ctx.c.FLAG_SELECTED,
        placeholder: _ctx.data.flag & _ctx.c.FLAG_PLACEHOLDER,
        leaving: _ctx.data.flag & _ctx.c.FLAG_LEAVING,
        error: _ctx.data.flag & _ctx.c.FLAG_LOAD_FAIL,
        [`p-outer--${_ctx.data.key}`]: true,
      }])
    }, [
      _cache[0] || (
        _setBlockTracking(-1, true),
        (_cache[0] = (!(_ctx.data.flag & _ctx.c.FLAG_PLACEHOLDER))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "select",
              onPointerdownPassive: ($event: any) => (_ctx.$emit('select', $event))
            }, [
              _createVNode(_component_CheckCircleIcon, { size: 18 })
            ], 40, _hoisted_2))
          : _createCommentVNode("", true)).cacheIndex = 0,
        _setBlockTracking(1),
        _cache[0]
      ),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRaw)
          ? (_openBlock(), _createBlock(_component_RawIcon, {
              key: 0,
              class: "raw",
              size: 28
            }))
          : _createCommentVNode("", true),
        (_ctx.data.flag & _ctx.c.FLAG_IS_VIDEO)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.data.video_duration)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.videoDuration), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_VideoIcon, { size: 22 })
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.liveid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "livephoto",
              onMouseenterPassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.playVideo && _ctx.playVideo(...args))),
              onMouseleavePassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopVideo && _ctx.stopVideo(...args))),
              onTouchstartPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchVideo && _ctx.touchVideo(...args)))
            }, [
              _createVNode(_component_LivePhotoIcon, {
                size: "22px",
                spin: _ctx.liveState.waiting,
                playing: _ctx.liveState.playing
              }, null, 8, ["spin", "playing"])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.data.flag & _ctx.c.FLAG_IS_FAVORITE)
          ? (_openBlock(), _createBlock(_component_StarIcon, {
              key: 0,
              size: 22
            }))
          : _createCommentVNode("", true),
        (_ctx.data.flag & _ctx.c.FLAG_IS_LOCAL)
          ? (_openBlock(), _createBlock(_component_LocalIcon, {
              key: 1,
              size: 22
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.showOwnerName && _ctx.sharedBy)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.sharedBy), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["img-outer fill-block", { 'memories-livephoto': _ctx.data.liveid }]),
        onContextmenu: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.contextmenu && _ctx.contextmenu(...args))),
        onPointerdownPassive: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('pointerdown', $event))),
        onTouchstartPassive: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touchstart', $event))),
        onTouchmove: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touchmove', $event))),
        onTouchendPassive: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touchend', $event))),
        onTouchcancelPassive: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touchend', $event)))
      }, [
        (_ctx.src)
          ? (_openBlock(), _createBlock(_component_XImg, {
              ref: "ximg",
              draggable: "false",
              class: _normalizeClass(["ximg fill-block no-user-select", [`memories-thumb-${_ctx.data.key}`]]),
              src: _ctx.src,
              key: _ctx.data.fileid,
              onLoad: _ctx.load,
              onError: _ctx.error
            }, null, 8, ["class", "src", "onLoad", "onError"]))
          : _createCommentVNode("", true),
        (_ctx.videoUrl)
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              ref: "video",
              src: _ctx.videoUrl,
              preload: "none",
              muted: "",
              playsinline: "",
              disableRemotePlayback: ""
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "overlay top-left fill-block" }, null, -1))
      ], 34)
    ], 2)
  ]))
}